module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAy0lEQVQ4T9VTsQ3CQAw8KzWLhJ4WIrECDStQgl7OBG9FULICDSsgoGYAxB6pI6O8Hokk/yACDV/ad/e+s0z48lGMn+d5qqrbuk9EC2vtNYSNCjDzBMDJkzIROf+JgB99DGAIYObH3gO4ATi2rXQyMMYMkiQ5qOro2TMRXaqqmhZFUTbqoWBaAT4gwSBfbWEJYO3ZKxHZBLfAzG5VIpK1Acy88715oOd4xMzqQdFpIjYd73cCADoW3pxJ00Lfm6ot1AeT9hQoPwou9MkdWP9T7qEBn2AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/icon-download@2x.png
// module id = 5dIK
// module chunks = 41